module.exports = __webpack_public_path__ + "static/media/dss.14cabfc6.gif";